var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.46 136.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #007896;\n      }\n\n      .cls-2 {\n        fill: #008779;\n      }\n\n      .cls-3 {\n        fill: #e5be20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.58,63.18l-42,42a13.73,13.73,0,0,0-4.16,10V136.1a53.25,53.25,0,0,0,48.45-66A50.82,50.82,0,0,0,102.58,63.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.87,33.63,60.59,57.92a13.73,13.73,0,0,0-4.16,10v32.34L99.73,57A175.37,175.37,0,0,0,84.87,33.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.43,0V53.05L81,28.48A359.3,359.3,0,0,0,56.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50,53.05V0A368.57,368.57,0,0,0,25.61,28.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.73,33.78A187.93,187.93,0,0,0,6.75,57L50,100.31V68a13.77,13.77,0,0,0-4.16-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.85,63.15C3.26,64.59,2.75,66,2.34,67.3A53.25,53.25,0,0,0,50,136.1V115.22a13.77,13.77,0,0,0-4.16-10Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.df2b5f0d.svg";
export { ForwardRef as ReactComponent };